import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const selectedStyles = (isDarkMode: boolean) => ({
  stroke: isDarkMode ? "black" : "white",
});

interface SatCurveProps extends SvgIconProps {
  isSelected?: boolean;
  fill?: string;
}

export const SatCurve: React.FC<SatCurveProps> = ({ isSelected, fill, ...props }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const iconColor =
    fill ||
    (isSelected ? selectedStyles(isDarkMode).stroke : theme.palette.brandedTypography.textColor);

  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      sx={{ fill: "none" }}
    >
      <path
        d="M1 1V19H19M16.5 2C15.3736 1.90373 13 1.83333 12 3.5C10.5 6 12.3397 11.4157 11 14C9.66027 16.5843 7.71068 15.8166 5 16"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default SatCurve;
